/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_Unlimited_ProjectsInputs */

const en_landing_pricing_feature_unlimited_projects = /** @type {(inputs: Landing_Pricing_Feature_Unlimited_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unlimited projects`)
};

const zh_landing_pricing_feature_unlimited_projects = /** @type {(inputs: Landing_Pricing_Feature_Unlimited_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无限项目`)
};

/**
* | output |
* | --- |
* | "Unlimited projects" |
*
* @param {Landing_Pricing_Feature_Unlimited_ProjectsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_unlimited_projects = /** @type {((inputs?: Landing_Pricing_Feature_Unlimited_ProjectsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_Unlimited_ProjectsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_unlimited_projects(inputs)
	return zh_landing_pricing_feature_unlimited_projects(inputs)
});
export { landing_pricing_feature_unlimited_projects as "landing.pricing.feature_unlimited_projects" }